import { render, staticRenderFns } from "./TableroHeader.vue?vue&type=template&id=97a4d15c&scoped=true"
import script from "./TableroHeader.vue?vue&type=script&lang=js"
export * from "./TableroHeader.vue?vue&type=script&lang=js"
import style0 from "./TableroHeader.vue?vue&type=style&index=0&id=97a4d15c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a4d15c",
  null
  
)

export default component.exports